import {inject, Injectable} from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class RouteGuardService {

  private router = inject(Router);
  private auth = inject(AuthService);

  canActivate(): boolean | UrlTree {
    if (this.auth.isUserLogged()) {
      return true;
    }

    this.auth.clearSession();
    return this.router.createUrlTree(['/login']);
  }
}
